import React from 'react';

const Card = ({ title, value, bcolor, faIcon, textColor }) => {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className={`card ${bcolor} shadow h-100 py-2`}>
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col mr-2">
              <div
                className={`text-xs font-weight-bold ${textColor} text-capitalize mb-1`}
              >
                {title}
              </div>
              <div className="h5 mb-0 font-weight-bold text-gray-800">
                {value}
              </div>
            </div>
            <div className="col-auto">
              <i className={`fas ${faIcon} fa-2x text-gray-300`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
